module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('ul', {
    staticClass: "more-list"
  }, _vm._l((_vm.data), function(item) {
    return _c('li', {
      attrs: {
        "data-id": item.id
      }
    }, [_vm._v(_vm._s(item.name))])
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7769439a"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./static/components/navbar/components/more-list.vue
// module id = 202
// module chunks = 1 2 3 4 5 6 7 8 9 10 12 13 15 16 17 19 24 27 28 33 37 39 40 44 46